export class StoryType {
    static readonly internal = 'internal';
    static readonly inbound = 'inbound';
}